<template>
     <div id="main-content">
        <div class="top-block phone-no-border">
            <div class="selected-item">
                <div>
                    <span class="title">Настройки аккаунта</span>
                </div>
                <user-info></user-info>
            </div>
        </div>
        <div class="general-form">
            <div class="info">
                <h3>Видео с примером подключения WiFi контроллера</h3>
                <video controls style="width: 100%">
                    <source src="/storage/help-video.mp4" type="video/mp4">
                </video>
                <br>
                <br>

                <h3>
                    Так же Вы можете
                    <a href="/storage/wifictrl-passport.pdf" target="_blank">скачать</a>
                    паспорт устройства с описанием подключения WiFi контроллера к разным моделям кондиционеров
                </h3>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .info{
        font-weight: 400;
        line-height: 20px;
        font-size: 16px;
        padding: 40px 30px;
        max-width: 800px;
        text-align: justify;

        a{
            color: #5EA9FF;
            &:hover{
                color: #4B87CC;
            }
            svg{
                height: 20px;
            }
        }

        h3{
            font-weight: 500;
        }
    }
</style>

<script>
    import userInfo from '../other/topUserInfo'

    export default {
        components:{
            userInfo,
        },
        data() {
            return { }
        }
    }
</script>
